/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_DescriptionInputs */

const ja_home_brands_description = /** @type {(inputs: Home_Brands_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINは、ゲームマーケティングやインフルエンサーマーケティング、ゲーム関連のWebプロダクトやECサービスの開発・運営を行っています。また、eスポーツイベントの制作・運営も主要な事業として展開しています。`)
};

const en_home_brands_description = /** @type {(inputs: Home_Brands_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN provides a broad range of services to support <strong>marketing, influencers, event and esports production for the games industry</strong>, while our dedicated brands each are positioned to fulfil a complimenatary niche.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN provides a broad range of services to support <strong>marketing, influencers, event and esports production for the games industry</strong>, while o..." |
*
* @param {Home_Brands_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_description = /** @type {((inputs?: Home_Brands_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_description(inputs)
	return en_home_brands_description(inputs)
});